import { Model } from "vue-mc";

export class AuthenticationModel extends Model {
  defaults() {
    return {
      username: ""
      , password: ""
      , newpassword: ""
      , confirmpassword: ""
    };
  }

  mutations() {
    return {
      username: (username) => username
      , password: (password) => password
      , newpassword: (newpassword) => newpassword
      , confirmpassword: (confirmpassword) => confirmpassword
    };
  }

  validation() {
    return {};
  }

  options() {
    return {
      validateOnSave: false
      , validateOnChange: false
      , validateRecursively: false
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/authentication.js